import { BlogIcon } from "../components/atoms/icons/sidebar/BlogIcon";
import { ClientIcon } from "../components/atoms/icons/sidebar/ClientIcon";
import { FeatureIcon } from "../components/atoms/icons/sidebar/FeatureIcon";
import { HomeIcon } from "../components/atoms/icons/sidebar/HomeIcon";
import { HomeImageIcon } from "../components/atoms/icons/sidebar/HomeImageIcon";
import { MemberIcon } from "../components/atoms/icons/sidebar/MemberIcon";
import { OwnerIcon } from "../components/atoms/icons/sidebar/OwnerIcon";
import { PopularPlaceIcon } from "../components/atoms/icons/sidebar/PopularPlaceIcon";
import { PropertyIcon } from "../components/atoms/icons/sidebar/PropertyIcon";
import { UserIcon } from "../components/atoms/icons/sidebar/UserIcon";
import { SidebarMenu } from "../ducks/app";
import { PageRoute } from "./routes";

export const SIDEBAR_MENUS: SidebarMenu[] = [
    {
        title: "Dashboard",
        path: PageRoute.HOME,
        icon: HomeIcon,
    },
    {
        title: "Properties",
        path: PageRoute.PROPERTIES,
        icon: PropertyIcon
    },
    {
        title: "Clients",
        path: PageRoute.CLIENTS,
        icon: ClientIcon
    },
    {
        title: "Owners",
        path: PageRoute.OWNERS,
        icon: OwnerIcon
    },
    {
        title: "Features",
        path: PageRoute.FEATURES,
        icon: FeatureIcon
    },
    {
        title: "Popular Places",
        path: PageRoute.POPULAR_PLACES,
        icon: PopularPlaceIcon
    },
    {
        title: "Blog",
        path: PageRoute.BLOG,
        icon: BlogIcon
    },
    {
        title: "Homepage Image",
        path: PageRoute.HOMEPAGE_IMAGE,
        icon: HomeImageIcon
    },
    {
        title: "Members",
        path: PageRoute.MEMBERS,
        icon: MemberIcon
    }
]